import { render } from "./DatabaseView.vue?vue&type=template&id=4cefc0e0&ts=true"
import script from "./DatabaseView.vue?vue&type=script&lang=ts"
export * from "./DatabaseView.vue?vue&type=script&lang=ts"

import "./DatabaseView.vue?vue&type=style&index=0&id=4cefc0e0&lang=css"

import exportComponent from "/home/runner/work/dashboard/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__